import { render, staticRenderFns } from "./BirdDogDialog.vue?vue&type=template&id=96852c7c&scoped=true&"
import script from "./BirdDogDialog.vue?vue&type=script&lang=js&"
export * from "./BirdDogDialog.vue?vue&type=script&lang=js&"
import style0 from "./BirdDogDialog.vue?vue&type=style&index=0&id=96852c7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96852c7c",
  null
  
)

export default component.exports